
(function() {
  // Ensure DOM is ready
  function onReady(callback) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      callback();
    } else {
      document.addEventListener('DOMContentLoaded', callback);
    }
  }

  // Wait for element to appear
  function waitForElement(selector, callback, timeout = 10000) {
    const el = document.querySelector(selector);
    if (el) return callback(el);

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        callback(el);
      }
    });

    const body = document.body;
    if (body) {
      observer.observe(body, { childList: true, subtree: true });
      if (timeout) setTimeout(() => observer.disconnect(), timeout);
    }
  }

  // Main logic
  onReady(() => {
    waitForElement('.limoniapps-notification li', (li) => {
      const notif = li.closest('.limoniapps-notification');
      const ul = notif ? notif.querySelector('.limoniapps-message-body ul') : null;
      if (!ul) return;

      // Convert <li> tags to <div> tags
      const html = ul.innerHTML
        .replaceAll(/<li/g, '<div')
        .replaceAll(/<\/li>/g, '</div>');

      const productForm = document.querySelector('#product-form-container');
      if (!productForm) return;

      // Find or create .discount-message after #product-form
      let discountMsg = document.querySelector('.discount-message');
      if (!discountMsg) {
        discountMsg = document.createElement('div');
        discountMsg.className = 'discount-message';
        productForm.insertAdjacentElement('afterend', discountMsg);
      }

      discountMsg.innerHTML = html;

      // Show the warranty message below the discount message, but only
      // when the active sale event has showWarrantyMessage enabled
      // (see event-config.liquid, mode: 'warranty'; set on window in theme.liquid)
      let warrantyMessage = window.warrantyMessage;
      if (warrantyMessage) {
        // [amount] is converted client-side via Shopify.currency.rate
        // (cart.currency.exchange_rate is unreliable in Liquid)
        if (warrantyMessage.includes('[amount]') && typeof formatPrice === 'function' && window.warrantyThreshold) {
          warrantyMessage = warrantyMessage.replace('[amount]', formatPrice(window.warrantyThreshold));
        }
        const warrantyEl = document.createElement('div');
        warrantyEl.className = 'warranty-message';
        warrantyEl.textContent = warrantyMessage;
        discountMsg.appendChild(warrantyEl);
      }

      // Hide the original notification
      notif.classList.add('hidden');
    });

    const primaryButton = document.querySelector('.guard-fit-button');
    const container = document.querySelector('#product-form-container');

    // Patch getElementById to also search open shadow roots —
    // Truemed internally queries #truemed-instructions after we move it into shadow DOM
    const _origGetById = Document.prototype.getElementById;
    Document.prototype.getElementById = function(id) {
      const el = _origGetById.call(this, id);
      if (el) return el;
      for (const host of document.querySelectorAll('*')) {
        if (host.shadowRoot) {
          const found = host.shadowRoot.querySelector('#' + CSS.escape(id));
          if (found) return found;
        }
      }
      return null;
    };

    // Truemed: load in regular DOM so script finds it, then move into shadow DOM
    // after population so event listeners are preserved
    waitForElement('#product-form-container', function(el) {
      const shadowRoot = el.shadowRoot;
      if (!shadowRoot) return;

      const addToCartBtn = shadowRoot.querySelector('.add-to-cart');
      if (!addToCartBtn) return;

      let truemedDiv = document.getElementById('truemed-instructions');
      if (!truemedDiv) {
        truemedDiv = document.createElement('div');
        truemedDiv.id = 'truemed-instructions';
        truemedDiv.style.fontSize = '14px';
        truemedDiv.setAttribute('icon-height', '12');
        truemedDiv.setAttribute('data-public-id', 'tm_qual_pjq29el3pd');
        truemedDiv.style.display = 'none';
        document.body.appendChild(truemedDiv);
      }

      document.querySelectorAll('script[src*="truemed"]').forEach(function(s) { s.remove(); });
      const script = document.createElement('script');
      script.src = 'https://static.truemed.com/widgets/product-page-widget.min.js?t=' + Date.now();
      document.body.appendChild(script);

      const truemedBox = shadowRoot.querySelector('.form-footer-box__truemed');

      new MutationObserver(function(mutations, obs) {
        if (truemedDiv.children.length > 0) {
          obs.disconnect();
          addToCartBtn.insertAdjacentElement('afterend', truemedDiv);

          const truemedBtn = truemedDiv.querySelector('button');
          if (truemedBox) {
            truemedBox.style.display = '';
            const link = truemedBox.querySelector('a');
            if (link && truemedBtn) {
              link.addEventListener('click', function(e) {
                e.preventDefault();
                truemedBtn.click();
              });
            }
          }
        }
      }).observe(truemedDiv, { childList: true });
    });

    if(container){
      const secondaryButton = container.shadowRoot.querySelector(
        '.guard-fit-button-second'
      );


      secondaryButton.addEventListener('click', function (e) {
        e.preventDefault();
        primaryButton.click();
      });



      const odOverlay = document.getElementById('OdOverlay');
      const odOpenElements = container?.shadowRoot ? container.shadowRoot.querySelectorAll('.od-info-link') : [];
      const odCloseX = document.getElementById('OdCloseX');

      function odOpen(){
        odOverlay.dataset.open = "true";
        odOverlay.setAttribute("aria-hidden", "false");
        // lock background scroll
        document.body.style.overflow = "hidden";
      }

      function odClose(){
        odOverlay.dataset.open = "false";
        odOverlay.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
        // quick reset so animation replays next open
        const odModal = odOverlay.querySelector('.od-modal');
        odModal.style.animation = "none";
        // force reflow
        void odModal.offsetHeight;
        odModal.style.animation = "";
      }

      // Attach click event to all elements with .input-opening-direction class
      odOpenElements.forEach(element => {
        element.addEventListener('click', odOpen);
      });

      odCloseX.addEventListener('click', odClose);

      // close on overlay click (but not when clicking modal)
      odOverlay.addEventListener('click', (e) => {
        if(e.target === odOverlay) odClose();
      });

      // close on Esc
      window.addEventListener('keydown', (e) => {
        if(e.key === 'Escape' && odOverlay.dataset.open === "true") odClose();
      });

    }
    

    
  });
})();



